// The honest online/offline signal — the mobile day-of surfaces are ONLINE-FIRST at go-live: no
// IndexedDB read-cache persistence ([post-launch]), just a truthful banner + disabled writes when the network
// is down. `navigator.onLine` + the `online`/`offline` window events are the browser/Capacitor-webview seam;
// on iOS the webview forwards reachability changes to these events. Defaults to ONLINE when the API is absent
// (SSR / a test JSDOM without navigator) so nothing false-flags offline.
import { useSyncExternalStore } from "react";

function subscribe(onChange: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
}

function getSnapshot(): boolean {
  if (typeof navigator === "undefined" || typeof navigator.onLine !== "boolean") return true;
  return navigator.onLine;
}

/** True when the device reports a network connection. Re-renders on `online`/`offline`. Assumes online when the
 * API is unavailable (never false-flags offline). */
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => true);
}
